// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__E3Kai","flash":"styles_flash__PqYx5"};